import React, {createContext, useEffect, useReducer, useState} from 'react';
import AppReducer from './AppReducer';
import { useNavigate, useLocation } from "react-router-dom";
import { useRoleContext } from "./RoleContext";
import { getRules, getSettings } from "../api/emailTriage";
import { determineCredentialsStatus, getUserData } from "../utils/common";

const initialState:any = {
   categories: {
     1: { id: 'Threat', text: 'Threat', value: 'Threat'},
     2: { id: 'Clean', text: 'Clean', value: 'Clean'},
     3: { id: 'Unknown', text: 'Unknown', value: 'Unknown'},
   },
   actionRules: [
        { text: 'Potential Threat', value: 0, id: 0 },
        { text: 'Clean email', value: 1, id: 1 },
        { text: 'Spam', value: 2, id: 2 },
   ],
    selectedEmail: {
        subject: '',
        email: '',
        reply_to: '',
        to: '',
        cc: '',
        reported_at: '',
        reported_by: '',
    },
    currentZone: null,
    isGlobal: false,
    ca: null,
    zones: [],
    isConfirmedNavigation: false,
    ms365: null,
    appReadyState: 'pending',
    globalZone: false,
}

export const GlobalContext = createContext(initialState);

export const GlobalProvider = ({ children, onZoneChanged } : {children:any, onZoneChanged:any}) => {
   const [state, dispatch] = useReducer(AppReducer, initialState);
   const [currentZone, setCurrentZone] = useState(sessionStorage.getItem('currentZone') || localStorage.getItem('currentZone') || /* istanbul ignore next */null)
   const navigate = useNavigate()
   const location = useLocation()
   const { setAutomationRulesStatus, credentialsStatus, setCredentialsStatus, setCredentialsDates } = useRoleContext()
   const currentUser = getUserData()
   const isLoggedIn = localStorage.getItem('isLoggedIn');
   const path = location.pathname.split('/')[1]

   useEffect(() => {
     const fromNodeChange = sessionStorage.getItem('fromChangeNode') || localStorage.getItem('fromChangeNode')
     if(fromNodeChange === '1') {
       const isGlobalZone = sessionStorage.getItem('globalZone') || localStorage.getItem('globalZone')
       if (isGlobalZone === 'true') {
         navigate('/settings/threat-exceptions')
       } else {
         if (location.pathname.includes('/inbox')) {
           navigate('/inbox')
         } else {
           navigate('/')
         }
       }

       localStorage.removeItem('fromChangeNode')
       sessionStorage.removeItem('fromChangeNode')
     }
     onZoneChanged()
   }, [currentZone])

  useEffect(() => {
    if (isLoggedIn) {
        getSettings({
            'task': 'get_accounts_data',
            'user_id': currentUser['id'],
            'user_email': currentUser['email'],
            'user_role': currentUser['role']
        }).then(res => {
            const tenantData = (({
                                 tenantId = null,
                                 phishClear = false,
                                 blocklist = false,
                                 automationPhishClear = false,
                                 automationBlocklist = false
                             }) => ({
                tenantId,
                phishClear,
                blocklist,
                automationPhishClear,
                automationBlocklist
            }))(res.data);
            const accountsData = res.data
            let currentCredentialStatus = determineCredentialsStatus(tenantData, accountsData)
            setCredentialsStatus(currentCredentialStatus);
            setCredentialsDates({
                autoPhishClear: accountsData.auto_phish_clear?.expired_at,
                autoBlockList: accountsData.auto_block_list?.expired_at,
            });
            const ruleData = res.data?.rules as never[]
            setAutomationRulesStatus({
                phishClear: ruleData.some(rule => {
                    const user_login_present = !!rule['phish_clear_user_login'] && rule['phish_clear_user_login'] !== '';
                    return rule['is_active'] && (rule['phish_clear'] || (currentCredentialStatus.autoPhishClear === 'error' && user_login_present))
                }),
                blockList: ruleData.some(rule => {
                    const user_login_present = !!rule['block_list_user_login'] && rule['block_list_user_login'] !== '';
                    return rule['is_active'] && (rule['block_list'] || (currentCredentialStatus.autoBlockList === 'error' && user_login_present))
                }),
            });
        })
    }
  }, [isLoggedIn, location.key, path, currentZone])

  // useEffect(() => {
  //   if (isLoggedIn) {
  //     getRules({ sortField: 'asc'}).then((response: any) => {
  //       const ruleData = response.data as never[]
  //       setAutomationRulesStatus({
  //         phishClear: ruleData.some(rule => {
  //           const user_login_present = !!rule['phish_clear_user_login'] && rule['phish_clear_user_login'] !== '';
  //           return rule['is_active'] && (rule['phish_clear'] || (credentialsStatus.autoPhishClear === 'error' && user_login_present))
  //         }),
  //         blockList: ruleData.some(rule => {
  //           const user_login_present = !!rule['block_list_user_login'] && rule['block_list_user_login'] !== '';
  //           return rule['is_active'] && (rule['block_list'] || (credentialsStatus.autoBlockList === 'error' && user_login_present))
  //         }),
  //       });
  //     })
  //   }
  // }, [isLoggedIn, credentialsStatus]);

   return(
      <GlobalContext.Provider value = {{globalState: state, globalDispatch: dispatch, reloadDispatcher: setCurrentZone}}>
        {  (children) }
      </GlobalContext.Provider>
   )
}
